import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  FormControl,
  Select,
  MenuItem,
  TablePagination,
  Tooltip,
  Input,
  InputAdornment,
} from "@material-ui/core/";
import SearchIcon from "@material-ui/icons/Search";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import moment from "moment";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { useSelector, useDispatch } from "react-redux";
import { isObjectEmpty, classStatusOptionList } from "../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../reduxSlices/loginSlice";
import Backdrop from "../../Backdrop";
import Aux from "../../../hoc/Auxilliary";
import MessageIndicator from "../../SnackBar";
import localizedStrings from "../../../utils/localize";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const useStyles = makeStyles({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },

  formControl: {
    color: "white",
    fontSize: "0.875rem",
  },
});

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

function PageConatiner(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [termsData, setTerms] = useState("");
  const [schoolsData, setSchoolsData] = useState("");
  const [tableMapData, setTableMapData] = useState([]);
  const [displayMessage, setDisplayMessage] = useState("");

  const [dptData, setDptData] = useState("");
  const [courseData, setCourseData] = useState("");
  const [facultyData, setfacultyData] = useState("");
  const [scheduleData, setScheduleData] = useState("");
  const classCourseData = useSelector(
    (state) => state.selectClassData.classCourseDataFromAPI,
  );

  const selectClassData = useSelector((state) => state.selectClassData.selectClassData);
  const price = useSelector((state) => state.selectClassData.price);
  const dataFetchingStatus = useSelector(
    (state) => state.selectClassData.dataFetchingStatus,
  );
  const errorMessage = useSelector((state) => state.selectClassData.errorMessage);

  const errorStatusCode = useSelector((state) => state.selectClassData.errorStatusCode);

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    props.history.push("/login");
  };

  useEffect(() => {
    if (!isObjectEmpty(classCourseData) && classCourseData !== undefined) {
      const removeEmptyObjmodalData = classCourseData?.filter(
        (value) => Object.keys(value).length !== 0
      );
      setTableMapData(removeEmptyObjmodalData);
    }
  }, [classCourseData]);

  const removeDuplicates = (data) => {
    return data?.filter((value) => Object.keys(value).length !== 0);
  };

  const handleChange = async (event) => {
    const copyTableMapData = [...classCourseData];
    if (event.target.name === "faculty") {
      var eventName = event?.target?.value?.toLowerCase();
      setfacultyData(event.target.value);
      setSchoolsData("");
      setTerms("");
      setDptData("");
      setCourseData("");
      setScheduleData("");
      if (event.target.value?.length === 0) {
        setTableMapData(removeDuplicates(copyTableMapData));
      } else {
        var copyDataa = [];
        copyTableMapData?.forEach(async (element) => {
          if (
            eventName &&
            element.ses_facultyname.some((name) =>
              name.toLowerCase().includes(eventName.toLowerCase()),
            )
          ) {
            copyDataa.push(element);
          }
          await setTableMapData(removeDuplicates(copyDataa));
        });
      }
    }

    if (event.target.name === "schedule") {
      var eventName = event?.target?.value?.toLowerCase();
      setScheduleData(event.target.value);
      setSchoolsData("");
      setTerms("");
      setDptData("");
      setCourseData("");
      setfacultyData("");
      if (event.target.value?.length === 0) {
        setTableMapData(removeDuplicates(copyTableMapData));
      } else {
        var copyDataa = [];
        copyTableMapData?.forEach(async (element) => {
          if (
            Object.keys(element).length !== 0 &&
            element?.ses_schedule != null &&
            element?.ses_schedule.toLowerCase().includes(eventName) === true
          ) {
            copyDataa.push(element);
          }
          await setTableMapData(removeDuplicates(copyDataa));
        });
        await setTableMapData(removeDuplicates(copyDataa));
      }
    }
    if (event.target.name === "term") {
      if (event.target.value?.length === 0) {
        setTableMapData(copyTableMapData);
      } else {
        let copyData = copyTableMapData.filter((element) => element.ses_term === event.target.value);
        setTableMapData(copyData);
      }

      setTerms(event.target.value);
      setSchoolsData("");
      setDptData("");
      setCourseData("");
      setfacultyData("");
      setScheduleData("");
    }
    if (event.target.name === "school") {
      if (event.target.value?.length === 0) {
        setTableMapData(copyTableMapData);
      } else {
        let copyData = copyTableMapData.filter((element) => element.ses_schoolname === event.target.value);
        setTableMapData(copyData);
      }

      setTerms("");
      setDptData("");
      setSchoolsData(event.target.value);
      setCourseData("");
      setfacultyData("");
      setScheduleData("");
    }
    if (event.target.name === "dept") {
      if (event.target.value?.length === 0) {
        setTableMapData(copyTableMapData);
      } else {
        let copyData = copyTableMapData.filter((element) => element.ses_departmentname === event.target.value);
        setTableMapData(copyData);
      }

      setDptData(event.target.value);
      setSchoolsData("");
      setTerms("");
      setCourseData("");
      setfacultyData("");
      setScheduleData("");
    }
    if (event.target.name === "course") {
      if (event.target.value?.length === 0) {
        console.log(copyTableMapData, "data");
        setTableMapData(copyTableMapData);
      } else {
        let copyData = copyTableMapData.filter((element) => element.ses_courseid === event.target.value);
        console.log(copyData, "data");
        setTableMapData(copyData);
      }

      setSchoolsData("");
      setTerms("");
      setDptData("");
      setfacultyData("");
      setScheduleData("");
      setCourseData(event.target.value);
    }
  };
  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: `${localizedStrings.general.sessionexpired}`,
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

 
  const handleClick = (e) => {
    e.preventDefault();

    props.history.push({
      pathname: "/students/select-class/checkout",
    });
  };
  const removeDuplicateFromObjects = (objectArray, field) => {
    if (objectArray?.length > 0) {
      if (field === "termName") {
        const sortedArray = [...objectArray]?.sort((a, b) => b.ses_startdate?.localeCompare(a.ses_startdate));

        const uniqueArray = sortedArray?.filter((v, i, a) => a.findIndex((t) => t.ses_term === v.ses_term) === i);
        // Sort the array by ses_enddate in ascending order (older to newer)
        uniqueArray.sort((a, b) => {
          if (a.ses_startdate === null && b.ses_startdate === null) {
            return 0;
          }
          if (a.ses_startdate === null) {
            return 1;
          }
          if (b.ses_startdate === null) {
            return -1;
          }
          return new Date(a.ses_startdate) - new Date(b.ses_startdate);
        });

        return uniqueArray;
      } else if (field === "schedule")
        return objectArray.filter((v, i, a) => a.findIndex((t) => t.ses_schedule === v.ses_schedule) === i);
      else if (field === "schoolName")
        return objectArray.filter((v, i, a) => a.findIndex((t) => t.ses_schoolname === v.ses_schoolname) === i);
      else if (field === "dept")
        return objectArray.filter((v, i, a) => a.findIndex((t) => t.ses_departmentname === v.ses_departmentname) === i);
      else if (field === "course")
        return objectArray.filter((v, i, a) => a.findIndex((t) => t.ses_courseid === v.ses_courseid) === i);
    }
    return [];
  };

  function formatCredits(credits) {
    if (credits === 0) {
      return "0,00";
    } else {
      return credits
        ?.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        .replace(".", ",");
    }
  }

  let tableData = "";
  let termData = "";
  let schoolData = "";
  let deptsData = "";
  let coursesData = "";

  if (!isObjectEmpty(classCourseData)) {
    if (classCourseData) {
      if (Array.isArray(classCourseData)) {
        tableData =
          tableMapData?.length > 0
            ? tableMapData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((element, index) => {
                  return (
                    <StyledTableRow key={index}>
                      <StyledTableCell>
                        {element.ses_schoolname === undefined ? "" : element.ses_schoolname}
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                        <HtmlTooltip
                          title={
                            <React.Fragment>
                              <Typography component="body" style={{ fontSize: "0.75rem" }}>
                                {localizedStrings.students.selectClasses.modalTable.class} - {element.ses_institutionclassid}
                              </Typography>
                              <Typography component="body" style={{ fontSize: "0.75rem" }}>
                                {localizedStrings.students.selectClasses.modalTable.startDate} - {element.ses_startdate !== null ? moment(element.ses_startdate).format("YYYY-MM-DD") : ""}
                              </Typography>
                              <Typography component="body" style={{ fontSize: "0.75rem" }}>
                                {localizedStrings.students.selectClasses.modalTable.endDate} - {element.ses_enddate !== null ? moment(element.ses_enddate).format("YYYY-MM-DD") : ""}
                              </Typography>
                              <Typography component="body" style={{ fontSize: "0.75rem" }}>
                                {localizedStrings.students.selectClasses.modalTable.room} - {element.ses_room}
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <Button>
                            {element.ses_term === null ? "" : element.ses_term} 
                          </Button>
                        </HtmlTooltip>
                      </StyledTableCell>

                      <StyledTableCell>
                        {element.ses_departmentname === undefined ? "" : element.ses_departmentname}
                      </StyledTableCell>
                      <StyledTableCell>
                        <HtmlTooltip
                          title={
                            <React.Fragment>
                              <Typography component="body" style={{ fontSize: "15px" }}>
                                {localizedStrings.students.selectClasses.description} - {element.ses_longdescription}
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <Button style={{ textAlign: "left" }}>
                            {element.ses_institutionclassid === null ? `${element?.ses_classname}` : ` ${element.ses_institutionclassid} - ${element?.ses_classname}`}
                            <br />
                            {element.ses_room}
                          </Button>
                        </HtmlTooltip>
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.usb_classnote ? element.usb_classnote : ""}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_schedule ? element.ses_schedule : ""}
                      </StyledTableCell>
                      <StyledTableCell>
                        {(() => {
                          const faculty = element?.ses_facultyname;
                          const facultyText = Array.isArray(faculty)
                            ? faculty.filter((name) => name != null && name !== "").join(", ")
                            : typeof faculty === "string"
                              ? faculty.trim()
                              : "";

                          return facultyText ? (
                            <Typography variant="body2" display="block">
                              {facultyText}
                            </Typography>
                          ) : null;
                        })()}
                      </StyledTableCell>

                      <StyledTableCell>
                        {formatCredits(element.ses_creditsavailable)}
                      </StyledTableCell>

                      <StyledTableCell>
                        <HtmlTooltip
                          title={
                            localizedStrings.students.selectClasses.modalTable
                              .reservedSeatsTooltip
                          }
                          disableHoverListener={Number(element?.ses_reservecapacity) <= 0}
                        >
                          <span style={{ display: "inline-block" }}>
                            {classStatusOptionList(element.ses_classstatus)}
                            <br />
                            {element?.ses_sessioncount && element?.ses_sessioncount != (undefined && null) ? element?.ses_sessioncount : 0}
                            /
                            {element?.ses_classcapacity && element?.ses_classcapacity != (undefined && null) ? element?.ses_classcapacity : 0}
                            {Number(element?.ses_reservecapacity) > 0 ? (
                              <>
                                <br />
                                [{element?.ses_reservecapacitysessioncount != null && element?.ses_reservecapacitysessioncount !== undefined ? element.ses_reservecapacitysessioncount : 0}/{element.ses_reservecapacity}]
                              </>
                            ) : null}
                          </span>
                        </HtmlTooltip>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })
            : null;

        termData = removeDuplicateFromObjects(classCourseData, "termName").map((element, index) => (
          <MenuItem value={element.ses_term} key={index} style={{ fontSize: "0.875rem" }}>
            {element.ses_term}
          </MenuItem>
        ));

        schoolData = removeDuplicateFromObjects(classCourseData, "schoolName").map((element, index) => (
          <MenuItem value={element.ses_schoolname} key={index} style={{ fontSize: "0.875rem" }}>
            {element.ses_schoolname}
          </MenuItem>
        ));

        deptsData = removeDuplicateFromObjects(classCourseData, "dept").map((element, index) => (
          <MenuItem value={element.ses_departmentname} key={index} style={{ fontSize: "0.875rem" }}>
            {element.ses_departmentname}
          </MenuItem>
        ));
        coursesData = removeDuplicateFromObjects(classCourseData, "course").map((element, index) => (
          <MenuItem value={element.ses_courseid} key={index} style={{ fontSize: "0.875rem" }}>
         {`${element.ses_courseid}${element.ses_coursename !== null ? ` - ${element.ses_coursename}` : ""}`}
          </MenuItem>
        ));
      }
    }
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (error.message === "Invalid token") {
      setDisplayMessage(localizedStrings.general.invalidToken);
    } else if (error.message === "Something Went Wrong") {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    } else {
      setDisplayMessage(error.message);
    }
  }, [error]);

  // Custom label for the "of" keyword in TablePagination
  const customLabelDisplayedRows = ({ from, to, count }) => {
    return `${from}-${to} ${localizedStrings.general.of} ${count}`;
  };

  return (
    <Aux>
      <MessageIndicator open={error.showSnackbar} message={displayMessage} handleClose={handleClose} />
      <Backdrop show={dataFetchingStatus} />
      <div>
        <div style={{ whiteSpace: "pre-line" }}>
          {localizedStrings.general.courseCatalogHeading}
        </div>
        <div>
          <InfoOutlinedIcon style={{ fontSize: "medium", margin: "0 0 -3px 0" }} />
          {localizedStrings.general.courseCatalogInformation}
        </div>
      </div>
      <TableContainer component={Paper} style={{ minHeight: "40vh", marginBottom: "10px" }}>
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.modalTable.schoolname} <br />
                <FormControl className={classes.formControl}>
                  <Select value={schoolsData} onChange={handleChange} className={classes.formControl} displayEmpty name="school">
                    <MenuItem value="" style={{ fontSize: "0.875rem" }}>
                      {localizedStrings.students.selectClasses.modalTable.allSchools}
                    </MenuItem>
                    {schoolData}
                  </Select>
                </FormControl>
              </StyledTableCell>
              <StyledTableCell className={classes.formRoot}>
                {localizedStrings.students.selectClasses.modalTable.term} <InfoOutlinedIcon style={{ fontSize: "medium", margin: "5px 0px -3px 2px" }} />
                <br />
                <FormControl className={classes.formControl}>
                  <Select value={termsData} onChange={handleChange} className={classes.formControl} displayEmpty name="term">
                    <MenuItem value="" style={{ fontSize: "0.875rem" }}>
                      {localizedStrings.students.selectClasses.modalTable.allTerms}
                    </MenuItem>
                    {termData}
                  </Select>
                </FormControl>
              </StyledTableCell>

              <StyledTableCell>
                {localizedStrings.students.selectClasses.modalTable.department}
                <br />
                <FormControl className={classes.formControl}>
                  <Select value={dptData} onChange={handleChange} className={classes.formControl} displayEmpty name="dept">
                    <MenuItem value="" style={{ fontSize: "0.875rem" }}>
                      {localizedStrings.students.selectClasses.modalTable.allDepartments}
                    </MenuItem>
                    {deptsData}
                  </Select>
                </FormControl>
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.modalTable.course}
                <InfoOutlinedIcon style={{ fontSize: "medium", margin: "5px 0px -4px 5px" }} />
                <FormControl className={classes.formControl} style={{ display: "flex" }}>
                  <Select value={courseData} onChange={handleChange} className={classes.formControl} displayEmpty name="course">
                    <MenuItem value="" style={{ fontSize: "0.875rem" }}>
                      {localizedStrings.students.selectClasses.modalTable.allCourses}
                    </MenuItem>
                    {coursesData}
                  </Select>
                </FormControl>
              </StyledTableCell>
              <StyledTableCell style={{ padding: "2px 16px 32px" }}>
                {localizedStrings.students.selectClasses.modalTable.classNotes}
              </StyledTableCell>
              <StyledTableCell style={{ width: "12%" }}>
                {localizedStrings.students.selectClasses.modalTable.schedule}
                <br />
                <Input value={scheduleData} onChange={handleChange} className={classes.formControl} displayEmpty name="schedule" startAdornment={<InputAdornment position="start"><SearchIcon style={{ color: "#ffffff" }} /></InputAdornment>} />
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.modalTable.faculty}
                <br />
                <Input value={facultyData} onChange={handleChange} className={classes.formControl} displayEmpty name="faculty" startAdornment={<InputAdornment position="start"><SearchIcon style={{ color: "#ffffff" }} /></InputAdornment>} />
               
              </StyledTableCell>

              <StyledTableCell style={{ padding: "2px 16px 32px" }}>
                {localizedStrings.students.selectClasses.modalTable.credits}
              </StyledTableCell>
              <StyledTableCell style={{ width: "15%", padding: "2px 16px 10px" }}>
                {localizedStrings.students.selectClasses.modalTable.classStatus}
                <br />
                {localizedStrings.students.selectClasses.modalTable.enrolled}
                 <div style={{ fontSize: "0.875rem", marginTop: 6 }}>
                 [{localizedStrings.students.selectClasses.modalTable.enrolledReserve}]
                </div>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{tableData}</TableBody>
        </Table>
        <TablePagination rowsPerPageOptions={[5, 10, 25, 100]} component="div" count={tableMapData?.length > 0 ? tableMapData?.length : 0} rowsPerPage={rowsPerPage} page={page} onChangePage={handleChangePage} onChangeRowsPerPage={handleChangeRowsPerPage} labelRowsPerPage={<span style={{ textTransform: "capitalize" }}>{localizedStrings.rows.rowsperpage}</span>} labelDisplayedRows={customLabelDisplayedRows} />
      </TableContainer>
      {selectClassData.length > 0 && (
        <Typography component="div" style={{ display: "flex", justifyContent: "flex-end", marginBottom: "1rem", width: "100%" }}>
          <Typography>
            <Button color="primary" style={{ textTransform: "capitalize" }} disableRipple>
              {`${localizedStrings.students.selectClasses.total} $ ${price}`}
            </Button>
          </Typography>
          <Button variant="outlined" color="primary" style={{ textTransform: "capitalize", marginLeft: "0.5rem" }} endIcon={<NavigateNextIcon />} onClick={handleClick}>
            {localizedStrings.students.selectClasses.next}
          </Button>
        </Typography>
      )}
    </Aux>
  );
}

export default withRouter(PageConatiner);
